
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
import "../styles/globals.scss"
import { useEffect } from "react"
import getConfig from "next/config"

const {
  publicRuntimeConfig: { GOOGLE_ANALYTICS_ID },
} = getConfig()

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    const reloadWindow = () => {
      let originalBodyStyle = getComputedStyle(document.body).getPropertyValue(
        "display"
      )
      document.body.style.display = "none"
      setTimeout(function () {
        document.body.style.display = originalBodyStyle
      }, 10)
    }

    window.removeEventListener("orientationchange", reloadWindow)
    window.addEventListener("orientationchange", reloadWindow)

    var _hsq = (window._hsq = window._hsq || [])
    _hsq.push([
      "addPrivacyConsentListener",
      function (consent) {
        if (!window?.google_tag_manager) {
          var gaScript = document.createElement("script")
          gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`
          document.head.append(gaScript)
        }

        const hasAnalyticsConsent = consent?.categories?.analytics || false
        const gaDisableCookieExists =
          document.cookie.indexOf(`ga-disable-${GOOGLE_ANALYTICS_ID}=true`) > -1

        gaScript.onload = function () {
          if (hasAnalyticsConsent) {
            if (gaDisableCookieExists) {
              document.cookie = `ga-disable-${GOOGLE_ANALYTICS_ID}=true; expires=Thu, 01 Jan 1970 00:00:01 UTC; path=/`
            }
            window[`ga-disable-${GOOGLE_ANALYTICS_ID}`] = false
            console.log("GA Tracking enabled")
          } else {
            if (!gaDisableCookieExists) {
              document.cookie = `ga-disable-${GOOGLE_ANALYTICS_ID}=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/`
            }
            window[`ga-disable-${GOOGLE_ANALYTICS_ID}`] = true
            console.log("GA Tracking disabled")
          }

          window.dataLayer = window.dataLayer || []
          function gtag() {
            dataLayer.push(arguments)
          }
          gtag("js", new Date())
          gtag("config", GOOGLE_ANALYTICS_ID)
        }
      },
    ])
  }, [])

  return <Component {...pageProps} />
}

const __Page_Next_Translate__ = MyApp


    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
    });
  